import {SagaIterator} from 'redux-saga';
import {call, put, select} from 'typed-redux-saga';
import {routerActions} from 'connected-react-router';
import {showSuccess, ErrorsFromBE, takeLeadingF, ErrorResponse} from 'favorlogic-utils';
import {StatusCodes} from 'http-status-codes';

import {StoreState} from 'app/types/StoreState';
import {handleResponseError} from 'utils/handleResponseError';

import {
    deleteMeasurementSuccess, deleteMeasurementError, DeleteMeasurementAction,
    setMeasurementDeleting, loadMeasurement, loadMeasurements,
} from '../actions';
import Api from '../api';

const title = 'Smazání měření';

function* handleErrorResponse(response: ErrorResponse): SagaIterator {
    yield* call(handleResponseError, response, title);
    yield* put(deleteMeasurementError(response.data as ErrorsFromBE));
}

function* handleSuccess(): SagaIterator {
    yield* put(showSuccess(title, 'Měření bylo úspěšně smazáno'));
    yield* put(deleteMeasurementSuccess());
    yield* put(routerActions.replace('/measurements'));
}

function* execute(action: DeleteMeasurementAction): SagaIterator {
    const {measurementId} = action.payload;
    yield* put(setMeasurementDeleting(true));
    try {
        const response = yield* call(Api.deleteMeasurement, measurementId);

        if (response.isSuccess) {
            yield* call(handleSuccess);
        } else if (response.status === StatusCodes.NOT_FOUND) {
            yield* put(deleteMeasurementSuccess());
            yield* put(routerActions.replace('/measurements'));
        } else {
            yield* call(handleErrorResponse, response);
            yield* put(loadMeasurement(measurementId));
        }
        const params = yield* select((state: StoreState) => state.measurement.measurementsParams);
        yield* put(loadMeasurements(params));
    } finally {
        yield* put(setMeasurementDeleting(false));
    }
}

export function* deleteMeasurementSaga(): SagaIterator {
    yield takeLeadingF('measurement/DELETE_MEASUREMENT', execute);
}
